import { defineNuxtPlugin, useRouter } from "#imports";
import { resetExposureTracking } from "../composables/useExperiments.js";
export default defineNuxtPlugin(() => {
  if (import.meta.server) return;
  const router = useRouter();
  router.afterEach((to, from) => {
    if (from.path !== to.path) {
      resetExposureTracking();
    }
  });
});
